<template>
  <div class="wrap">
    <div class="main">
      <!-- 新增跳转引导 -->
      <!-- <div class="loadPageMess">
        <p>资质、品牌被冒用类问题，点击<a href="//about.58.com/voteProof?voteSource=2&cateCode=0&from=voteProof2_0">企业冒用</a></p>
        <p>订单、交易、定金类问题，点击<a href="//weiquan.58.com/complaint/index?terminal=1">我要维权</a></p>
        <p>信息内容虚假、违规类问题，点击下方举报原因</p>
      </div> -->
      <!-- 举报原因 -->
      <div class="reasonWrap">
        <h5>请选择举报原因</h5>
        <div class="cate infoCate" v-for="item in reasonList" :key="item.id">
          <p class="tit">{{item.name}}</p>
          <label ref="choose" v-for="data in item.children" :key="data.id">
            <span>{{data.name}}</span>
            <input :type="chooseType" @click="reasonClassFlag($event , data.id)" />
            <i class="icon"></i>
          </label>
        </div>
      </div>
      <!--温馨提示 -->
      <Tips :tips="tips" v-show="checkReason != ''"></Tips>
      <!-- 必填项 -->
      <div id="require">
        <component v-for="Name in mustComponent" :key="Name.index" :is="Name" mustFlag="show"
          @transMess="getTransMess(arguments , ['mess'])"></component>
      </div>
      <!-- 选填项 -->
      <div id="select" v-show="noMustComponent.length != 0">
        <div class="tit" :class="selectState" @click="selectFlag">
          <span>填写更多信息(可不填)</span>
          <i></i>
        </div>
        <div class="components" v-show="noMustFlag">
          <component v-for="Name in noMustComponent" :key="Name.index" :is="Name" mustFlag="hide"
            @transMess="getTransMess(arguments , ['mess'])"></component>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <div class="footer">
      <div class="btn" :class="submitState" @click="submitVote">提交</div>
    </div>
  </div>
</template>

<script>
  import "./userVote.less";
  import axios from "axios";
  import {
    getReasonList,
    getCompomentState,
    submitData
  } from "../../components/api/request.js";

  import utils from "../../utils/index.js";

  import DatePicker from "../../components/dataPicker/DatePicker.vue";
  import NameFill from "../../components/NameFill/NameFill.vue";
  import IdFill from "../../components/IdFill/IdFill.vue";
  import PhoneFill from "../../components/PhoneFill/PhoneFill.vue";
  import CodeFill from "../../components/CodeFill/CodeFill.vue";
  import MoneyFill from "../../components/MoneyFill/MoneyFill.vue";
  import ExplainFill from "../../components/ExplainFill/ExplainFill.vue";
  import PicLoad from "../../components/PicLoad/PicLoad.vue";
  import EmailFill from "../../components/EmailFill/EmailFill.vue";
  import Tips from "../../components/Tips/index.vue";


  export default {
    data() {
      return {
        // 模板id
        templateId: "",
        // param
        param: "",
        // 单多选
        chooseType: "radio",
        // 获取reasonlist
        reasonList: "",
        // 提交-选中的reason存储
        checkReason: "",
        // 提交按钮状态
        submitState: "un",
        // 选填状态开关
        selectState: "un",
        // 必填组件
        mustComponent: [],
        // 非必填组件
        noMustComponent: [],
        // 非必填组件打开开关
        noMustFlag: false,
        // 子传父的值
        mess: "",
        // 身份证号
        idnum: "",
        // 手机号
        phonenum: "",
        //邮箱
        email: "",
        // responseid
        responseid: "",
        // 验证码
        codenum: "",
        // 说明文字
        desc: "",
        // 金额
        moneynum: "",
        // 姓名
        name: "",
        // 图片
        imgUrl: [],
        // 时间
        time: "",
        // 是否登录
        isLogin: "",
        // 温馨提示
        tips: undefined,
        // 模板是否需要后置登录
        isNeedLogin: false,
        infoId: ""
      };
    },
    components: {
      DatePicker,
      NameFill,
      IdFill,
      PhoneFill,
      CodeFill,
      MoneyFill,
      ExplainFill,
      PicLoad,
      EmailFill,
      Tips
    },
    mounted() {
      if (this.chooseType == "checkbox") {
        this.checkReason = [];
      } else {
        this.checkReason = "";
      }
    },
    created() {
      this.InitPage()
    },
    methods: {
      async InitPage() {
        await this.reason();
        await this.isNeedAutoSubmit();
      },
      isNeedAutoSubmit() {
        if (localStorage.getItem("isNeedAutoSubmit") && this.isLogin) {
          this.submitAction();
        }
      },

      // 获取reasonlist
      async reason() {
        // TODO:
        this.param = this.getQueryString("param");
        let sceneid = this.getQueryString("sceneid");
        let data = await getReasonList(sceneid, this.param);
        // let data = await getReasonList()
        // TODO:
        data.code != 1 ? this.$toast("请重新获取") : null;
        this.reasonList = data.data.reasons;
        this.templateId = data.data.templateId;
        this.isLogin = data.data.isLogin;
        this.infoId = data.data.infoId;
      },
      // reason选中class切换
      reasonClassFlag(eve, val) {
        if (this.chooseType == "radio" && isNaN(eve)) {
          // 单选逻辑
          // 删除label的on样式
          for (let i = 0; i < this.$refs.choose.length; i++) {
            let classlist = this.$refs.choose[i].classList;
            classlist.remove("on");
          }
          // 获取当前元素的父元素及classlist
          const labelNode = event.target.parentNode;
          const classList = labelNode.classList;
          classList.add("on");
          this.submitState = "on";
          this.checkReason = val;
        } else if (this.chooseType == "checkbox" && isNaN(eve)) {
          // 多选逻辑
          const labelNode = event.target.parentNode;
          const classList = labelNode.classList;
          this.checkReason.push(val);
          if (classList.contains("on")) {
            classList.remove("on");
          } else {
            classList.add("on");
          }
        }
        // 选中后请求组件数据
        this.componentState();
      },
      // 选填项控制
      selectFlag() {
        if (this.selectState == "un") {
          this.selectState = "on";
          this.noMustFlag = true;
        } else {
          this.selectState = "un";
          this.noMustFlag = false;
        }
      },
      // 获取组件状态并分类
      async componentState() {
        let templateId = this.templateId;
        let reasonId = this.checkReason;
        let data = await getCompomentState(templateId, reasonId);
        data.status != 0 ? this.$toast("请重新获取") : null;
        let componentData = data.attachlist;
        // 将字符串分割  变为 数组
        this.tips = data.description;
        this.mustComponent = [];
        this.noMustComponent = [];

        let isLoginIndex = componentData
          .map(item => {
            return item.letterName;
          }).indexOf("login");

        this.isNeedLogin = isLoginIndex !== -1 && componentData[isLoginIndex].isRequired == 1

        for (let i in componentData) {
          let lettername = componentData[i].letterName;
          let name = "";
          switch (lettername) {
            case "cheatdate":
              name = "DatePicker";
              break;

            case "applyname":
              name = "NameFill";
              break;

            case "identitycard":
              name = "IdFill";
              break;

            case "cheatmoney":
              name = "MoneyFill";
              break;

            case "votephone":
              name = "PhoneFill";
              break;

            case "captcha":
              name = "CodeFill";
              break;

            case "votecontent":
              name = "ExplainFill";
              break;

            case "picupload":
              name = "PicLoad";
              break;
            case "email":
              name = "EmailFill";
              break;
            default:
              break;
          }

          if (componentData[i].isRequired == 1 && lettername !== "login") {
            this.mustComponent.push(name);
          } else if (lettername !== "login") {
            this.noMustComponent.push(name);
          }
        }
      },
      // 获取子传父的值
      getTransMess(argument, ele) {
        if (argument.length == 4) {
          this[argument[0][0]] = argument[0][1];
          this[argument[0][2]] = argument[0][3];
          return;
        }
        this[argument[0][0]] = argument[0][1];
        this[argument[0][2]] = argument[0][3];
      },
      // 判断是否为空
      checkEmpty(ele, mess) {
        if (this[ele] == "") {
          this.$toast(mess);
        }
      },
      // 姓名只能包含汉字
      checkApplyName(name) {
        if (name.length < 2) {
          this.$toast("姓名只能输入2-5个汉字");
          return false;
        } else {
          let reg = /^[\u4E00-\u9FA5]+$/;
          if (!reg.test(name)) {
            this.$toast("姓名只能包含汉字");
            return false;
          }
          return true;
        }
      },
      // 身份证号字符校验
      checkIdentityCard(id) {
        let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!regIdNo.test(id)) {
          this.$toast("请输入正确的身份证号");
          return false;
        }
        return true;
      },
      //邮箱校验
      emailCheck(email) {
        const szReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!szReg.test(email)) {
          this.$toast("请输入正确的邮箱");
          return false;
        }
        return true;
      },
      // 手机号校验
      phoneCheck(phone) {
        //手机号正则
        var phoneReg = /^1[2|3|4|5|6|7|8|9|][0-9]{9}$/;
        //电话
        if (!phoneReg.test(phone)) {
          this.$toast("请输入正确的手机号");
          return false;
        }
        return true;
      },
      // 获取url字段值
      getQueryString(name) {
        let reg = `(^|&)${name}=([^&]*)(&|$)`;
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
      // 提交投诉
      async submitVote() {
        if (this.submitState == "un") {
          return;
        }
        // 必填项校验
        for (let i = 0; i < this.mustComponent.length; i++) {
          switch (this.mustComponent[i]) {
            case "DatePicker":
              this.time = document.getElementById("nowValue").value;
              if (this.time == "") {
                this.$toast("请选择受骗时间");
                return false;
              }
              continue;

            case "NameFill":
              if (this.name == "") {
                this.$toast("请输入受骗人姓名");
                return false;
              }
              //this.checkApplyName(this.name);
              if (this.name.length < 2) {
                this.$toast("姓名只能输入2-5个汉字");
                return false;
              } else {
                let reg = /^[\u4E00-\u9FA5]+$/;
                if (!reg.test(this.name)) {
                  this.$toast("姓名只能包含汉字");
                  return false;
                }
              }
              continue;

            case "IdFill":
              if (this.idnum == "") {
                this.$toast("请输入身份证号");
                return false;
              }

              //this.checkIdentityCard(this.idnum);
              let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
              if (!regIdNo.test(this.idnum)) {
                this.$toast("请输入正确的身份证号");
                return false;
              }
              continue;
            case "EmailFill":
              if (this.email == "") {
                this.$toast("请输入邮箱号");
                return false;
              }
              //this.emailCheck(this.email);
              const szReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
              if (!szReg.test(this.email)) {
                this.$toast("请输入正确的邮箱");
                return false;
              }
              continue;
            case "MoneyFill":
              if (this.moneynum == "") {
                this.$toast("请输入受骗金额");
                return false;
              }
              continue;

            case "PhoneFill":
              if (this.phonenum == "") {
                this.$toast("请输入手机号");
                return false;
              }
              if (!this.phoneCheck(this.phonenum)) {
                return;
              }
              continue;

            case "CodeFill":
              if (this.codenum == "") {
                this.$toast("请输入验证码");
                return false;
              }
              if (this.responseid == "" || this.responseid == "undefined") {
                this.$toast("请获取验证码后提交");
                return;
              }
              continue;

            case "ExplainFill":
              if (this.desc == "") {
                this.$toast("请输入说明文字");
                return false;
              }
              continue;

            case "PicLoad":
              if (this.imgUrl.length == "0") {
                this.$toast("请上传证据图片");
                return;
              }
              continue;

            default:
              continue;
          }
        }
        // 非必填项校验
        if (this.noMustComponent.length != 0) {
          for (let m = 0; m < this.noMustComponent.length; m++) {
            if (this.noMustComponent[m] == "IdFill") {
              if (this.idnum != "") {
                if (!this.checkIdentityCard(this.idnum)) {
                  return;
                }
              }
            }
            if (this.noMustComponent[m] == "NameFill") {
              if (this.name != "") {
                if (!this.checkApplyName(this.name)) {
                  return;
                }
              }
            }
            if (this.noMustComponent[m] == "EmailFill") {
              if (this.email != "") {
                if (!this.emailCheck(this.email)) {
                  return;
                }
              }
            }
            if (this.noMustComponent[m] == "PhoneFill") {
              if (this.phonenum != "") {
                if (!this.phoneCheck(this.phonenum)) {
                  return;
                }
              }
            }
            if (this.noMustComponent[m] == "CodeFill") {
              if (this.codenum != "") {
                if (this.responseid == "" || this.responseid == "undefined") {
                  this.$toast("请获取验证码后提交");
                  return;
                }
              }
            }
          }
        }
        // TODO: 临时添加时间默认值
        this.time = document.getElementById("nowValue") ?
          document.getElementById("nowValue").value :
          "";
        await this.submitAction();
      },
      getCookie(name, from, point) {
        var name = name + "=";
        var place = from || document.cookie
        var splitPoint = point || ";"
        var ca = place.split(splitPoint);
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i].trim();
          if (c.indexOf(name) == 0) {
            return c.substring(name.length,
              c.length);
          }
        }
        return "";
      },
      async submitAction() {
        this.submitState = "un";
        let cooper = this.getCookie("58cooper")
        let userId = this.getCookie("userid", cooper.replace(/"/g, ""), "&")
        // 提交
        let param = localStorage.getItem("param") ?
          localStorage.getItem("param") :
          this.param;
        let reasonid = localStorage.getItem("checkReason") ?
          localStorage.getItem("checkReason") :
          this.checkReason;
        let votephone = localStorage.getItem("phonenum") ?
          localStorage.getItem("phonenum") :
          this.phonenum;
        let identitycard = localStorage.getItem("idnum") ?
          localStorage.getItem("idnum") :
          this.idnum;
        let votecontent = localStorage.getItem("desc") ?
          localStorage.getItem("desc") :
          this.desc;
        let picupload = localStorage.getItem("imgUrl") ?
          localStorage.getItem("imgUrl") :
          this.imgUrl;
        let cheatdate = localStorage.getItem("cheatdate") ?
          localStorage.getItem("cheatdate") :
          this.time;
        let applyname = localStorage.getItem("name") ?
          localStorage.getItem("name") :
          this.name;
        let cheatmoney = localStorage.getItem("moneynum") ?
          localStorage.getItem("moneynum") :
          this.moneynum;
        let captcha = localStorage.getItem("codenum") ?
          localStorage.getItem("codenum") :
          this.codenum;
        let responseid = localStorage.getItem("responseid") ?
          localStorage.getItem("responseid") :
          this.responseid;
        let email = localStorage.getItem("email") ?
          localStorage.getItem("email") :
          this.email;
        let sceneid = this.getQueryString("sceneid");
        //
        if (this.isNeedLogin && !this.isLogin) {
          var _fromurl = encodeURIComponent(window.location.href);
          localStorage.setItem("param", this.param);
          localStorage.setItem("checkReason", reasonid);
          localStorage.setItem("phonenum", votephone);
          localStorage.setItem("idnum", identitycard);
          localStorage.setItem("desc", votecontent);
          localStorage.setItem("imgUrl", picupload);
          localStorage.setItem("cheatdate", cheatdate);
          localStorage.setItem("name", applyname);
          localStorage.setItem("moneynum", cheatmoney);
          localStorage.setItem("codenum", captcha);
          localStorage.setItem("responseid", responseid);
          localStorage.setItem("email", email);
          localStorage.setItem("isNeedAutoSubmit", true);
          window.location.href = "//m.m.58.com/login/?path=" + _fromurl;
        } else {
          let data = await submitData(
            param,
            reasonid,
            votephone,
            identitycard,
            votecontent,
            picupload,
            cheatdate,
            applyname,
            cheatmoney,
            captcha,
            responseid,
            email,
            sceneid
          );
          if (data.code == 5 || data.code == 4) {
            this.$toast("请输入正确的验证码");
          } else if (data.code == 6) {
            this.$toast("验证码超时，请重新获取");
          } else if (data.code == 12) {// 增加事中策略逻辑 mashuting01
            this.$toast(`${data.msg}`);
          } else {
            clickLog("from=58_M_submit_button");
            localStorage.clear();
            // 跳转成功逻辑
            if (this.isLogin) {
              // 跳转查看进度成功页
              this.$router.push({
                path: "/vote/entrance/SuccessLog",
                query: {
                  infourl: data.jump.infourl
                }
              });
            } else {
              // 跳转赚积分成功页
              this.$router.push({
                path: "/vote/entrance/SuccessNoLog",
                query: {
                  infourl: data.jump.infourl
                }
              });
            }
          }
        }
        this.submitState = "on";
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/UserVote/UserVote.vue